require('../scss/lightcase.scss');

import 'lightcase';

if (lightcase) {
	if (jQuery('.woocommerce-product-gallery').length) {
		jQuery('.woocommerce-product-gallery').each(function () {
			jQuery('a', this).attr('data-rel', 'lightcase:product-gallery');
		});
	}


	jQuery('a[data-rel^=lightcase]').lightcase({
		swipe: true,
		transition: 'elastic',
		overlayOpacity: .8
	});

	jQuery('a[data-rel^=lightcase-ajax]').lightcase({
		type: 'ajax',
		fullscreenModeForMobile: false,
		transition: 'elastic',
		maxHeight: 800,
		overlayOpacity: .8,
		onFinish: {
			fix: function () {
				jQuery('.woocommerce-product-gallery').each(function () {
					jQuery('a', this).preventDefault;
					jQuery(this).css('opacity', '1');
				});
			}
		}
	});

	jQuery('#cc-trigger').lightcase({
		swipe: true,
		transition: 'elastic',
		overlayOpacity: .8,
		onFinish: {
			populate: function () {
				var formData = jQuery('#nlbox').val();
				jQuery('#email_address_0').val(formData);
			}
		}
	});
	jQuery('#cc-trigger').click(function (event) {
		event.preventDefault();
	});
}